import { useState } from "react";
import { QrPlaceholder } from "@/components/contact/QrPlaceholder";
import { siteConfig } from "@/config/site";
import { copyToClipboard } from "@/lib/intake";

type ContactQrStepProps = {
  summary?: string | null;
  showCopySummary?: boolean;
};

export function ContactQrStep({ summary, showCopySummary = false }: ContactQrStepProps) {
  const { contact } = siteConfig;
  const [qrFailed, setQrFailed] = useState(false);
  const [copyState, setCopyState] = useState<"idle" | "ok" | "fail">("idle");

  const showQrImage = contact.qrImage.length > 0 && !qrFailed;

  const handleCopy = async () => {
    if (!summary) return;
    const ok = await copyToClipboard(summary);
    setCopyState(ok ? "ok" : "fail");
    if (ok) window.setTimeout(() => setCopyState("idle"), 2000);
  };

  return (
    <>
      <div className="text-center">
        <p className="kicker mb-2.5">ASTRA · 留学管家</p>
        <h2
          id="contact-title"
          className="text-2xl font-bold leading-tight tracking-tight text-ink-900"
        >
          添加专属顾问,
          <br />
          <span className="text-coral-700">继续你的咨询。</span>
        </h2>
        <p className="mt-3 text-[13px] leading-relaxed text-ink-600">
          {showCopySummary
            ? "长按识别下方企微二维码。加好后可将需求摘要粘贴给顾问。"
            : contact.subtitle}
        </p>
      </div>

      <div className="mt-5">
        {showQrImage ? (
          <img
            src={contact.qrImage}
            alt="顾问企微二维码"
            className="mx-auto block w-[232px] rounded-[20px] border border-[var(--line)]"
            onError={() => setQrFailed(true)}
          />
        ) : (
          <QrPlaceholder />
        )}
      </div>

      {showCopySummary && summary ? (
        <button
          type="button"
          onClick={handleCopy}
          className="mt-4 w-full rounded-xl border border-coral-200 bg-coral-50 py-3 text-[13px] font-semibold text-coral-900"
        >
          {copyState === "ok"
            ? "已复制到剪贴板"
            : copyState === "fail"
              ? "复制失败，请长按下方文字手动复制"
              : "复制需求摘要"}
        </button>
      ) : null}

      {showCopySummary && summary && copyState === "fail" ? (
        <pre className="mt-2 max-h-28 overflow-y-auto whitespace-pre-wrap rounded-lg bg-surface-50 p-3 text-[11px] leading-relaxed text-ink-600">
          {summary}
        </pre>
      ) : null}

      <p className="mt-5 text-center text-[12.5px] text-ink-600">{contact.scanHint}</p>
      <p className="mt-2 text-center font-mono text-[11px] tracking-wide text-ink-400">
        {contact.replyTimeHint}
      </p>
    </>
  );
}
